// extracted by mini-css-extract-plugin
export default {"generalBlock":"General_generalBlock__1qDh4","generalContent":"General_generalContent__WxCJf"};